// Generated by ReScript, PLEASE EDIT WITH CARE


function makeGridCols(cols) {
  switch (cols) {
    case 2 :
        return "grid-cols-2";
    case 3 :
        return "grid-cols-3";
    case 4 :
        return "grid-cols-4";
    case 5 :
        return "grid-cols-5";
    case 6 :
        return "grid-cols-6";
    case 7 :
        return "grid-cols-7";
    case 8 :
        return "grid-cols-8";
    case 9 :
        return "grid-cols-9";
    case 10 :
        return "grid-cols-10";
    default:
      return "grid-cols-1";
  }
}

function makeColSpan(cols) {
  switch (cols) {
    case 1 :
        return "col-span-1";
    case 2 :
        return "col-span-2";
    case 3 :
        return "col-span-3";
    case 4 :
        return "col-span-4";
    case 5 :
        return "col-span-5";
    case 6 :
        return "col-span-6";
    case 7 :
        return "col-span-7";
    case 8 :
        return "col-span-8";
    case 9 :
        return "col-span-9";
    default:
      return "col-span-10";
  }
}

function makeGridRows(rows) {
  switch (rows) {
    case 1 :
        return "grid-rows-1";
    case 2 :
        return "grid-rows-2";
    case 3 :
        return "grid-rows-3";
    case 4 :
        return "grid-rows-4";
    case 5 :
        return "grid-rows-5";
    default:
      return "grid-rows-6";
  }
}

function makeRowSpan(rows) {
  switch (rows) {
    case 1 :
        return "row-span-1";
    case 2 :
        return "row-span-2";
    case 3 :
        return "row-span-3";
    case 4 :
        return "row-span-4";
    case 5 :
        return "row-span-5";
    case 6 :
        return "row-span-6";
    default:
      return "row-span-10";
  }
}

export {
  makeGridCols ,
  makeColSpan ,
  makeGridRows ,
  makeRowSpan ,
}
/* No side effect */
